export const getImage = (name: string) => {

    const basename = getBaseName() ?? '/portal';

    try {
        return require(`../clients-data`+ basename + "/" + name);
    } catch (error) {
        console.error("Image not found:", name);
        return null;
    }

};


export function getBaseName() {
    // Example: Extract base path from the current URL
    try {
        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        return pathSegments.length > 0 ? `/${pathSegments[0]}` : '/';
    } catch {
        return '/portal';
    }

}
